import { Controller } from "@hotwired/stimulus";
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

export default class extends Controller {
  static targets = ["swiperContainer", "prevButton", "nextButton"]
  static values = {
    slidesPerView: { type: Number, default: 4 },
    spaceBetween: { type: Number, default: 20 }
  }

  connect() {
    this.initializeSwiper();
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  initializeSwiper() {
    const slideCount = this.swiperContainerTarget.querySelectorAll('.swiper-slide').length;
    const config = this.getSwiperConfig(slideCount);

    const swiper = new Swiper(this.swiperContainerTarget, config);

    this.swiper = swiper;
  }

  getSwiperConfig(slideCount) {
    const baseConfig = {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: slideCount >= 4,
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
      breakpoints: this.getBreakpoints(slideCount)
    };

    return baseConfig;
  }

  getBreakpoints(slideCount) {
    const breakpointMaps = {
      1: {
        576: { slidesPerView: 1 },
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 1 }
      },
      2: {
        576: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 }
      },
      3: {
        576: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 3 }
      }
    };

    return breakpointMaps[slideCount] || {
      576: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 }
    };
  }

  updateNavigationButtons(swiper) {
    if (this.prevButtonTarget) {
      this.prevButtonTarget.disabled = swiper.isBeginning;
      this.prevButtonTarget.classList.toggle('disabled', swiper.isBeginning);
    }

    if (this.nextButtonTarget) {
      this.nextButtonTarget.disabled = swiper.isEnd;
      this.nextButtonTarget.classList.toggle('disabled', swiper.isEnd);
    }
  }
}
